import { getDataMapper, mapArray, mapField } from "@/shared";

export const mapAttachmentFromServer = getDataMapper({
    id: mapField("id", Number),
    url: mapField("url"),
    name: mapField("name"),
    mime: mapField("mime"),
});

export const mapAttachmentsFromServer = mapArray(mapAttachmentFromServer);

export const mapIssueFromServer = getDataMapper({
    id: mapField("id", Number),
    directorId: mapField("director_id", Number),
    directorName: mapField("director_name"),
    description: mapField("description"),
    status: mapField("status"),
    reportedToTeam: mapField("reported_to_team", Boolean),
    reportedAt: mapField("reported_at"),
    resolution: mapField("resolution"),
    resolvedAt: mapField("resolved_at"),
    isRepeat: mapField("is_repeat", Boolean),
    link: mapField("link"),
    resolutionMinutes: mapField("resolution_minutes", Number),
    createdUserName: mapField("created_user_name"),
    createdAt: mapField("created_at"),
    attachments: mapField("attachments", mapAttachmentFromServer),
});

export const mapIssuesFromServer = mapArray(mapIssueFromServer);
